import { Browser } from "../../core/browser";
import { AuxiliumComponent } from "../auxilium-component";

export default class FrameSidebar extends AuxiliumComponent {
  static observable = ["padding", "collapsed", "heading", "heading-caption", "brand", "brand-icon", "brand-caption", "side", "heading-size", "brand-icon-size", "brand-size"];
  static observableBooleans = ["collapsible", "responsive"];

  constructor() {
    super();

    const preloadCollapse = window.localStorage.getItem("collapseSidebar");

    this.side ??= "left";
    this.headingSize ??= "4";
    this.description = this.getAttribute("description") ?? this.heading ?? Localizer.SIDEBAR_DESCRIPTION;
    this.padding = this.getAttribute("padding") ?? (this.closest("chip-frame").layout !== "container" ? "xl" : "0");
    this.collapsed = preloadCollapse != null && this.collapsible ? preloadCollapse === "true" : this.hasAttribute("collapse");
    this.brandSize ??= "4";
    this.brandIconSize ??= "20";
  }

  parsedCallback() {
    const nav = document.createElementWithContents("nav", this.querySelector(":scope>ul") ?? this.appendChild(document.createElementWithContents("ul", null, { className: "sidebar__list" })), { ariaLabel: this.description });

    if (this.headingCaption) {
      nav.prepend(document.createElementWithContents("chip-text", this.headingCaption));
    }

    if (this.heading) {
      nav.prepend(document.createElementWithContents("chip-header", this.heading, {
        size: this.headingSize,
        element: "h2"
      }));
    }

    if (this.brand || this.collapsible) {
      const topbar = document.createElementWithContents("div", null, { className: "sidebar__top" });

      if (this.brand) {
        const caption = this.brandCaption ? `<chip-text weight="regular" class="sidebar-brand--caption" size="body">${this.brandCaption}</chip-text>` : "";

        topbar.appendChild(document.createElementWithContents("chip-header",
          `
          <div class="h-align gap-md">
            ${this.brandIcon ? `<img height="${this.brandIconSize}" width="${this.brandIconSize}" src="${Browser.ResolveRelativeURL(this.brandIcon)}" alt="Sidebar brand icon">` : ""}
            <div>
              ${this.brand}
              ${caption}
            </div>
          </div>
          `, {
          size: this.brandSize,
          link: "~/",
          className: "sidebar-brand"
        }));
      }

      if (this.collapsible) {
        topbar.appendChild(document.createElementWithContents("chip-button", null, {
          variation: "body",
          buttonStyle: "icon",
          className: "btn--collapse-sidebar",
          tooltip: Localizer.TOGGLE_SIDEBAR_BUTTON,
          size: "lg",
          icon: `fas ${this.collapsed ? "fa-bars" : "fa-arrow-left"}`,
          onclick: () => this.collapsed = !this.collapsed
        }));
      }

      nav.prepend(topbar);
    }

    nav.append(...[...this.childNodes].filter(x => !x.matches?.("chip-sidebaritem, chip-sidebarheader")));
    this.appendChild(nav);

    this.querySelectorAll(":scope > chip-sidebaritem, :scope > chip-sidebarheader").forEach(x => this.AddItem(x));
    this.#RefreshTooltips();

    this.refreshActiveItem();
  }

  AddItem(item) {
    this.querySelector(":scope>ul, :scope>nav>ul").appendChild(document.createElementWithContents("li", item, { className: item.nodeName === "CHIP-SIDEBARITEM" ? "sidebar-list-item" : "sidebar-list__section-title" }))
  }

  ClearItems() {
    this.querySelector(":scope>ul, :scope>nav>ul").innerHTML = "";
  }

  refreshActiveItem() {
    const currentURL = location.toString().toLowerCase(),
      eligibleItems = [...this.querySelectorAll("chip-sidebaritem[link]")]
        .filter(x => x.link && currentURL.startsWith(Browser.ResolveRelativeURL(x.link).toLowerCase()));

    const target = eligibleItems.find(item => Browser.ResolveRelativeURL(item.link).toLowerCase() === currentURL)
      ?? eligibleItems.find(item => !eligibleItems.find(x => Browser.GetPaths(Browser.ResolveRelativeURL(x.link)).length > Browser.GetPaths(Browser.ResolveRelativeURL(item.link)).length));

    if (target) {
      target.setAttribute("active", "");
    }
  }

  attributeChanged(name, _, newValue) {
    if (name === "collapsed") {
      const collapsed = this.IsAttributeValueTrue(newValue),
        button = this.querySelector(".btn--collapse-sidebar");

      window.localStorage.setItem("collapseSidebar", collapsed);

      if (collapsed) { this.querySelectorAll("chip-sidebaritem").forEach(x => x.Close()); }
      if (button) { button.icon = `fas ${collapsed ? "fa-bars" : "fa-arrow-left"}`; }

      this.#RefreshTooltips();
    }
  }

  #RefreshTooltips() {
    this.querySelectorAll("chip-button[variation='sidebar']").forEach(button => {
      button.tooltip = this.collapsed ? (button.textContent.trim() ?? "") : "";
    });
  }
}
